// "Último dato": la lectura fallo y se muestra lo anterior (rediseño §6.9).
// Va en la cabecera del panel, en ambar, sin tapar la lista: el portal sigue
// reintentando solo.
import { Icon } from "../components/ui/icon.js";

export function StaleTag({ children = "Último dato recibido" }: { children?: React.ReactNode }): React.JSX.Element {
  return (
    <span role="status" className="inline-flex items-center gap-1.5 whitespace-nowrap text-eyebrow text-ambar" title="No se pudo actualizar: se muestra lo último recibido y se reintenta sola.">
      <Icon name="sinConexion" className="size-3.5" />
      {children}
    </span>
  );
}
